<div *ngIf="isShortLoading" class="message__textbox">
  <div class="loader"></div>
</div>

<div *ngIf="!isShortLoading" class="loader__message">
  <p class="highlight-text">{{ text }}</p>
  <div class="loader2"></div>
</div>
